import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SkipCashReturn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [params, setParams] = useState({});
  const [pendingOrders, setPendingOrders] = useState([]);

  useEffect(() => {
    // Capture all URL parameters
    const urlParams = new URLSearchParams(location.search);
    const paramObj = {};
    for (const [key, value] of urlParams.entries()) {
      paramObj[key] = value;
    }
    setParams(paramObj);

    // Get all pending orders
    const orders = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('pendingOrder_')) {
        try {
          const orderData = JSON.parse(localStorage.getItem(key));
          const transactionId = key.replace('pendingOrder_', '');
          orders.push({
            storageKey: key,
            transactionId,
            ...orderData
          });
        } catch (e) {
          console.error('Failed to parse pending order:', e);
        }
      }
    }
    setPendingOrders(orders);

    console.log('SkipCash Return Debug:', {
      url: window.location.href,
      params: paramObj,
      pendingOrders: orders
    });
  }, [location]);

  const proceedToOrderConfirmation = () => {
    // Redirect to order confirmation with current parameters
    navigate(`/order-confirmation${location.search}`);
  };

  return (
    <div>
      <Header />
      <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
        <h1>SkipCash Return Debug</h1>
        <p>This page shows what SkipCash sent back to us.</p>
        
        <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3>URL Parameters Received:</h3>
          <pre style={{ background: '#fff', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(params, null, 2)}
          </pre>
        </div>

        <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3>Full URL:</h3>
          <pre style={{ background: '#fff', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
            {window.location.href}
          </pre>
        </div>

        <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3>Pending Orders in localStorage:</h3>
          {pendingOrders.length === 0 ? (
            <p>No pending orders found</p>
          ) : (
            pendingOrders.map((order, index) => (
              <div key={index} style={{ 
                background: '#fff', 
                padding: '10px', 
                marginBottom: '10px', 
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}>
                <strong>Storage Key:</strong> {order.storageKey}<br/>
                <strong>Transaction ID:</strong> {order.transactionId}<br/>
                <strong>Total:</strong> QAR {order.totalPrice}<br/>
                <strong>Items:</strong> {order.cartItems?.length || 0}<br/>
                <strong>Created:</strong> {order.createdAt}
              </div>
            ))
          )}
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button 
            onClick={proceedToOrderConfirmation}
            style={{ 
              background: '#28a745', 
              color: 'white', 
              border: 'none', 
              padding: '12px 24px', 
              borderRadius: '4px', 
              cursor: 'pointer' 
            }}
          >
            Proceed to Order Confirmation
          </button>
          
          <button 
            onClick={() => navigate('/payment-recovery')}
            style={{ 
              background: '#007cba', 
              color: 'white', 
              border: 'none', 
              padding: '12px 24px', 
              borderRadius: '4px', 
              cursor: 'pointer' 
            }}
          >
            Go to Payment Recovery
          </button>
          
          <button 
            onClick={() => navigate('/')}
            style={{ 
              background: '#6c757d', 
              color: 'white', 
              border: 'none', 
              padding: '12px 24px', 
              borderRadius: '4px', 
              cursor: 'pointer' 
            }}
          >
            Go Home
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SkipCashReturn; 